import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../../common/modules/admin/services/AdminService';
import { SessionService } from '../../common/modules/admin/services/SessionService';
import { UserService } from '../../common/modules/user/services/UserService';
import {
  devEnv,
  localEnv,
  testEnv,
  stagingEnv,
  procEnv,
  demoEnv,
  bisHanoiEnv,
  bisHanoiDevEnv,
  bisHanoiStagingEnv,
  ishcmcEnv,
  aavnIshcmcEnv,
  primaryIshcmcEnv,
  secondaryIshcmcEnv,
  isspEnv,
  demoHelenEnv,
} from '../../common/config/config';

@Component({
  selector: 'navigate-page',
  template: require('./NavigateComponent.html'),
  styles: [require('./NavigateComponent.sass')],
})
export class NavigateComponent implements OnInit {
  private sidebarStatus: boolean;
  private hostName: string;
  message: string;
  messageType: string;
  adminData: any;
  userData: any;
  myaisToken: any;
  role: any;

  constructor(
    protected router: Router,
    protected userService: UserService,
    protected sessionService: SessionService,
    protected adminService: AdminService
  ) {
    this.sidebarStatus = false;
  }

  ngOnInit() {
    this.getSession();
    this.sidebarStatus = false;
    this.hostName = window.location.hostname;
    console.log(this.hostName);
  }

  toAsa() {
    switch (this.hostName) {
      case procEnv.auth:
        window.location.href = `https://${procEnv.asa}/asa/admin/`;
        break;
      case devEnv.auth:
        window.location.href = `http://${devEnv.asa}/asa/admin/`;
        break;
      case testEnv.auth:
        window.location.href = `http://${testEnv.asa}/asa/admin/`;
        break;
      case bisHanoiEnv.auth:
        window.location.href = `http://${bisHanoiEnv.asa}/asa/admin/`;
        break;
      case bisHanoiDevEnv.auth:
        window.location.href = `http://${bisHanoiDevEnv.asa}/asa/admin/`;
        break;
      case bisHanoiStagingEnv.auth:
        window.location.href = `http://${bisHanoiStagingEnv.asa}/asa/admin/`;
        break;
      case ishcmcEnv.auth:
        window.location.href = `http://${ishcmcEnv.asa}/asa/admin/`;
        break;
      case aavnIshcmcEnv.auth:
        window.location.href = `http://${aavnIshcmcEnv.asa}/asa/admin/`;
        break;
      case primaryIshcmcEnv.auth:
        window.location.href = `http://${primaryIshcmcEnv.asa}/asa/admin/`;
        break;
      case secondaryIshcmcEnv.auth:
        window.location.href = `http://${secondaryIshcmcEnv.asa}/asa/admin/`;
        break;
      case isspEnv.auth:
        window.location.href = `http://${isspEnv.asa}/asa/admin/`;
        break;
      case demoHelenEnv.auth:
        window.location.href = `http://${demoHelenEnv.asa}/asa/admin/`;
        break;
      case stagingEnv.auth:
        window.location.href = `https://${stagingEnv.asa}/asa/admin/`;
        break;
      case demoEnv.auth:
        window.location.href = `http://${demoEnv.asa}/asa/admin/`;
        break;
      default:
        window.location.href = `http://${localEnv.asa}/asa/admin/`;
        break;
    }
  }

  toHoliday() {
    switch (this.hostName) {
      case procEnv.auth:
        window.location.href = `https://${procEnv.holiday}/holiday/admin/`;
        break;
      case devEnv.auth:
        window.location.href = `http://${devEnv.holiday}/holiday/admin/`;
        break;
      case testEnv.auth:
        window.location.href = `http://${testEnv.holiday}/holiday/admin/`;
        break;
      case bisHanoiEnv.auth:
        window.location.href = `http://${bisHanoiEnv.holiday}/holiday/admin/`;
        break;
      case bisHanoiDevEnv.auth:
        window.location.href = `http://${bisHanoiDevEnv.holiday}/holiday/admin/`;
        break;
      case bisHanoiStagingEnv.auth:
        window.location.href = `http://${bisHanoiStagingEnv.holiday}/holiday/admin/`;
        break;
      case ishcmcEnv.auth:
        window.location.href = `http://${ishcmcEnv.holiday}/holiday/admin/`;
        break;
      case aavnIshcmcEnv.auth:
        window.location.href = `http://${aavnIshcmcEnv.holiday}/holiday/admin/`;
        break;
      case primaryIshcmcEnv.auth:
        window.location.href = `http://${primaryIshcmcEnv.holiday}/holiday/admin/`;
        break;
      case secondaryIshcmcEnv.auth:
        window.location.href = `http://${secondaryIshcmcEnv.holiday}/holiday/admin/`;
        break;
      case isspEnv.auth:
        window.location.href = `http://${isspEnv.holiday}/holiday/admin/`;
        break;
      case demoHelenEnv.auth:
        window.location.href = `http://${demoHelenEnv.holiday}/holiday/admin/`;
        break;
      case stagingEnv.auth:
        window.location.href = `https://${stagingEnv.holiday}/holiday/admin/`;
        break;
      case demoEnv.auth:
        window.location.href = `http://${demoEnv.holiday}/holiday/admin/`;
        break;
      default:
        window.location.href = `http://${localEnv.holiday}/holiday/admin/`;
        break;
    }
  }

  toCamp() {
    switch (this.hostName) {
      case procEnv.auth:
        window.location.href = `https://${procEnv.camp}/camp/admin/`;
        break;
      case devEnv.auth:
        window.location.href = `http://${devEnv.camp}/camp/admin/`;
        break;
      case testEnv.auth:
        window.location.href = `http://${testEnv.camp}/camp/admin/`;
        break;
      case bisHanoiEnv.auth:
        window.location.href = `http://${bisHanoiEnv.camp}/camp/admin/`;
        break;
      case bisHanoiDevEnv.auth:
        window.location.href = `http://${bisHanoiDevEnv.camp}/camp/admin/`;
        break;
      case bisHanoiStagingEnv.auth:
        window.location.href = `http://${bisHanoiStagingEnv.camp}/camp/admin/`;
        break;
      case ishcmcEnv.auth:
        window.location.href = `http://${ishcmcEnv.camp}/camp/admin/`;
        break;
      case aavnIshcmcEnv.auth:
        window.location.href = `http://${aavnIshcmcEnv.camp}/camp/admin/`;
        break;
      case primaryIshcmcEnv.auth:
        window.location.href = `http://${primaryIshcmcEnv.camp}/camp/admin/`;
        break;
      case secondaryIshcmcEnv.auth:
        window.location.href = `http://${secondaryIshcmcEnv.camp}/camp/admin/`;
        break;
      case isspEnv.auth:
        window.location.href = `http://${isspEnv.camp}/camp/admin/`;
        break;
      case demoHelenEnv.auth:
        window.location.href = `http://${demoHelenEnv.camp}/camp/admin/`;
        break;
      case stagingEnv.auth:
        window.location.href = `https://${stagingEnv.camp}/camp/admin/`;
        break;
      case demoEnv.auth:
        window.location.href = `http://${demoEnv.camp}/camp/admin/`;
        break;
      default:
        window.location.href = `http://${localEnv.camp}/camp/admin/`;
        break;
    }
  }

  toBus() {
    switch (this.hostName) {
      case procEnv.auth:
        window.location.href = `https://${procEnv.bus}/bus/admin/`;
        break;
      case devEnv.auth:
        window.location.href = `http://${devEnv.bus}/bus/admin/`;
        break;
      case testEnv.auth:
        window.location.href = `http://${testEnv.bus}/bus/admin/`;
        break;
      case bisHanoiEnv.auth:
        window.location.href = `http://${bisHanoiEnv.bus}/bus/admin/`;
        break;
      case bisHanoiDevEnv.auth:
        window.location.href = `http://${bisHanoiDevEnv.bus}/bus/admin/`;
        break;
      case bisHanoiStagingEnv.auth:
        window.location.href = `http://${bisHanoiStagingEnv.bus}/bus/admin/`;
        break;
      case ishcmcEnv.auth:
        window.location.href = `http://${ishcmcEnv.bus}/bus/admin/`;
        break;
      case aavnIshcmcEnv.auth:
        window.location.href = `http://${aavnIshcmcEnv.bus}/bus/admin/`;
        break;
      case primaryIshcmcEnv.auth:
        window.location.href = `http://${primaryIshcmcEnv.bus}/bus/admin/`;
        break;
      case secondaryIshcmcEnv.auth:
        window.location.href = `http://${secondaryIshcmcEnv.bus}/bus/admin/`;
        break;
      case isspEnv.auth:
        window.location.href = `http://${isspEnv.bus}/bus/admin/`;
        break;
      case demoHelenEnv.auth:
        window.location.href = `http://${demoHelenEnv.bus}/bus/admin/`;
        break;
      case stagingEnv.auth:
        window.location.href = `https://${stagingEnv.bus}/bus/admin/`;
        break;
      case demoEnv.auth:
        window.location.href = `http://${demoEnv.bus}/bus/admin/`;
        break;
      default:
        window.location.href = `http://${localEnv.bus}/bus/admin/`;
        break;
    }
  }

  toConferenceBooking() {
    switch (this.hostName) {
      case procEnv.conference:
        window.location.href = `https://${procEnv.conference}/conference/admin/`;
        break;
      case devEnv.auth:
        window.location.href = `http://${devEnv.conference}/conference/admin/`;
        break;
      case testEnv.auth:
        window.location.href = `http://${testEnv.conference}/conference/admin/`;
        break;
      case bisHanoiEnv.auth:
        window.location.href = `http://${bisHanoiEnv.conference}/conference/admin/`;
        break;
      case bisHanoiDevEnv.auth:
        window.location.href = `http://${bisHanoiDevEnv.conference}/conference/admin/`;
        break;
      case bisHanoiStagingEnv.auth:
        window.location.href = `http://${bisHanoiStagingEnv.conference}/conference/admin/`;
        break;
      case ishcmcEnv.auth:
        window.location.href = `http://${ishcmcEnv.conference}/conference/admin/`;
        break;
      case aavnIshcmcEnv.auth:
        window.location.href = `http://${aavnIshcmcEnv.conference}/conference/admin/`;
        break;
      case primaryIshcmcEnv.auth:
        window.location.href = `http://${primaryIshcmcEnv.conference}/conference/admin/`;
        break;
      case secondaryIshcmcEnv.auth:
        window.location.href = `http://${secondaryIshcmcEnv.conference}/conference/admin/`;
        break;
      case isspEnv.auth:
        window.location.href = `http://${isspEnv.conference}/conference/admin/`;
        break;
      case demoHelenEnv.auth:
        window.location.href = `http://${demoHelenEnv.conference}/conference/admin/`;
        break;
      case stagingEnv.auth:
        window.location.href = `https://${stagingEnv.conference}/conference/admin/`;
        break;
      case demoEnv.auth:
        window.location.href = `http://${demoEnv.conference}/conference/admin/`;
        break;
      default:
        window.location.href = `http://${localEnv.conference}/conference/admin/`;
        break;
    }
  }

  toAccessControl() {
    switch (this.hostName) {
      case 'auth.aisvietnam.com':
        window.location.href = 'https://acs.aisvietnam.com/';
        break;
      case devEnv.auth:
        window.location.href = 'http://acs.vas.dev.nascorp.vn/';
        break;
      case 'auth.eca.test.nascorp.vn':
        window.location.href = 'http://acs.eca.test.nascorp.vn/';
        break;
      case 'uat-auth.aisvietnam.com':
        window.location.href = 'https://uat-acs.aisvietnam.com/';
        break;
      default:
        window.location.href = 'http://acs.local.vas.dev.nascorp.vn/';
        break;
    }
  }
  toAnnouncementsManagement() {
    switch (this.hostName) {
      case devEnv.auth:
        window.location.href = `http://${devEnv.event}/admin`;
        break;
      case testEnv.auth:
        window.location.href = `http://${testEnv.event}/admin`;
        break;
      case bisHanoiEnv.auth:
        window.location.href = `http://${bisHanoiEnv.event}/admin`;
        break;
      case bisHanoiDevEnv.auth:
        window.location.href = `http://${bisHanoiDevEnv.event}/admin`;
        break;
      case bisHanoiStagingEnv.auth:
        window.location.href = `http://${bisHanoiStagingEnv.event}/admin`;
        break;
      case ishcmcEnv.auth:
        window.location.href = `http://${ishcmcEnv.event}/admin`;
        break;
      case aavnIshcmcEnv.auth:
        window.location.href = `http://${aavnIshcmcEnv.event}/admin`;
        break;
      case primaryIshcmcEnv.auth:
        window.location.href = `http://${primaryIshcmcEnv.event}/admin`;
        break;
      case secondaryIshcmcEnv.auth:
        window.location.href = `http://${secondaryIshcmcEnv.event}/admin`;
        break;
      case isspEnv.auth:
        window.location.href = `http://${isspEnv.event}/admin`;
        break;
      case demoHelenEnv.auth:
        window.location.href = `http://${demoHelenEnv.event}/admin`;
        break;
      case procEnv.auth:
        window.location.href = `https://${procEnv.event}/admin`;
        break;
      case stagingEnv.auth:
        window.location.href = `https://${stagingEnv.event}/admin`;
        break;
      case demoEnv.auth:
        window.location.href = `http://${demoEnv.event}/admin`;
        break;
      default:
        window.location.href = `https://${localEnv.event}/admin`;
        break;
    }
  }

  toChatHistory() {
    switch (this.hostName) {
      case devEnv.auth:
        window.location.href = `http://${devEnv.history}`;
        break;
      case testEnv.auth:
        window.location.href = `http://${testEnv.history}`;
        break;
      case bisHanoiEnv.auth:
        window.location.href = `http://${bisHanoiEnv.history}`;
        break;
      case bisHanoiDevEnv.auth:
        window.location.href = `http://${bisHanoiDevEnv.history}`;
        break;
      case bisHanoiStagingEnv.auth:
        window.location.href = `http://${bisHanoiStagingEnv.history}`;
        break;
      case ishcmcEnv.auth:
        window.location.href = `http://${ishcmcEnv.history}`;
        break;
      case aavnIshcmcEnv.auth:
        window.location.href = `http://${aavnIshcmcEnv.history}`;
        break;
      case primaryIshcmcEnv.auth:
        window.location.href = `http://${primaryIshcmcEnv.history}`;
        break;
      case secondaryIshcmcEnv.auth:
        window.location.href = `http://${secondaryIshcmcEnv.history}`;
        break;
      case isspEnv.auth:
        window.location.href = `http://${isspEnv.history}`;
        break;
      case demoHelenEnv.auth:
        window.location.href = `http://${demoHelenEnv.history}`;
        break;
      case procEnv.auth:
        window.location.href = `https://${procEnv.history}`;
        break;
      case stagingEnv.auth:
        window.location.href = `https://${stagingEnv.history}`;
        break;
      case demoEnv.auth:
        window.location.href = `http://${demoEnv.history}`;
        break;
      default:
        window.location.href = `https://${localEnv.history}`;
        break;
    }
  }

  toParentMeeting() {
    switch (this.hostName) {
      case devEnv.auth:
        window.location.href = `http://${devEnv.meeting}`;
        break;
      case testEnv.auth:
        window.location.href = `http://${testEnv.meeting}`;
        break;
      case bisHanoiEnv.auth:
        window.location.href = `http://${bisHanoiEnv.meeting}`;
        break;
      case bisHanoiDevEnv.auth:
        window.location.href = `http://${bisHanoiDevEnv.meeting}`;
        break;
      case bisHanoiStagingEnv.auth:
        window.location.href = `http://${bisHanoiStagingEnv.meeting}`;
        break;
      case ishcmcEnv.auth:
        window.location.href = `http://${ishcmcEnv.meeting}`;
        break;
      case aavnIshcmcEnv.auth:
        window.location.href = `http://${aavnIshcmcEnv.meeting}`;
        break;
      case primaryIshcmcEnv.auth:
        window.location.href = `http://${primaryIshcmcEnv.meeting}`;
        break;
      case secondaryIshcmcEnv.auth:
        window.location.href = `http://${secondaryIshcmcEnv.meeting}`;
        break;
      case isspEnv.auth:
        window.location.href = `http://${isspEnv.meeting}`;
        break;
      case demoHelenEnv.auth:
        window.location.href = `http://${demoHelenEnv.meeting}`;
        break;
      case procEnv.auth:
        window.location.href = `https://${procEnv.meeting}`;
        break;
      case stagingEnv.auth:
        window.location.href = `https://${stagingEnv.meeting}`;
        break;
      case demoEnv.auth:
        window.location.href = `http://${demoEnv.meeting}`;
        break;
      default:
        window.location.href = `https://${localEnv.meeting}`;
        break;
    }
  }

  toEnrolment() {
    switch (this.hostName) {
      case devEnv.auth:
        window.location.href = `http://${devEnv.enrolment}/admin`;
        break;
      case testEnv.auth:
        window.location.href = `http://${testEnv.enrolment}/admin`;
        break;
      case bisHanoiEnv.auth:
        window.location.href = `http://${bisHanoiEnv.enrolment}/admin`;
        break;
      case bisHanoiDevEnv.auth:
        window.location.href = `http://${bisHanoiDevEnv.enrolment}/admin`;
        break;
      case bisHanoiStagingEnv.auth:
        window.location.href = `http://${bisHanoiStagingEnv.enrolment}/admin`;
        break;
      case ishcmcEnv.auth:
        window.location.href = `http://${ishcmcEnv.enrolment}/admin`;
        break;
      case aavnIshcmcEnv.auth:
        window.location.href = `http://${aavnIshcmcEnv.enrolment}/admin`;
        break;
      case primaryIshcmcEnv.auth:
        window.location.href = `http://${primaryIshcmcEnv.enrolment}/admin`;
        break;
      case secondaryIshcmcEnv.auth:
        window.location.href = `http://${secondaryIshcmcEnv.enrolment}/admin`;
        break;
      case isspEnv.auth:
        window.location.href = `http://${isspEnv.enrolment}/admin`;
        break;
      case demoHelenEnv.auth:
        window.location.href = `http://${demoHelenEnv.enrolment}/admin`;
        break;
      case procEnv.auth:
        window.location.href = `https://${procEnv.enrolment}/admin`;
        break;
      case stagingEnv.auth:
        window.location.href = `https://${stagingEnv.enrolment}/admin`;
        break;
      case demoEnv.auth:
        window.location.href = `http://${demoEnv.enrolment}/admin`;
        break;
      default:
        window.location.href = `https://${localEnv.enrolment}/admin`;
        break;
    }
  }

  private getSession(): void {
    this.sessionService.getSession().subscribe(
      (user) => {
        this.userData = user;
        // this.adminData = this.adminService.getAdminSessionData();
        // this.role = this.adminData.role
        this.role = this.userData.role;
        console.log(this.role);
      },
      (error) => {
        //TO DO: Handle any error if needed in the furture
        this.message = '';
        this.messageType = 'alert';
      }
    );
  }

  toMyAis() {
    this.myAisToken();
    // window.open('http://myais.vn', '_blank')
  }

  // Convert string SHA1
  SHA1(msg: any) {
    function rotate_left(n: any, s: any) {
      var t4 = (n << s) | (n >>> (32 - s));
      return t4;
    }
    function lsb_hex(val: any) {
      var str = '';
      var i;
      var vh;
      var vl;
      for (i = 0; i <= 6; i += 2) {
        vh = (val >>> (i * 4 + 4)) & 0x0f;
        vl = (val >>> (i * 4)) & 0x0f;
        str += vh.toString(16) + vl.toString(16);
      }
      return str;
    }
    function cvt_hex(val: any) {
      var str = '';
      var i;
      var v;
      for (i = 7; i >= 0; i--) {
        v = (val >>> (i * 4)) & 0x0f;
        str += v.toString(16);
      }
      return str;
    }
    function Utf8Encode(string: any) {
      string = string.replace(/\r\n/g, '\n');
      var utftext = '';
      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if (c > 127 && c < 2048) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }
      }
      return utftext;
    }
    var blockstart;
    var i, j;
    var W = new Array(80);
    var H0 = 0x67452301;
    var H1 = 0xefcdab89;
    var H2 = 0x98badcfe;
    var H3 = 0x10325476;
    var H4 = 0xc3d2e1f0;
    var A, B, C, D, E;
    var temp;
    msg = Utf8Encode(msg);
    var msg_len = msg.length;
    var word_array = new Array();
    for (i = 0; i < msg_len - 3; i += 4) {
      j =
        (msg.charCodeAt(i) << 24) |
        (msg.charCodeAt(i + 1) << 16) |
        (msg.charCodeAt(i + 2) << 8) |
        msg.charCodeAt(i + 3);
      word_array.push(j);
    }
    switch (msg_len % 4) {
      case 0:
        i = 0x080000000;
        break;
      case 1:
        i = (msg.charCodeAt(msg_len - 1) << 24) | 0x0800000;
        break;
      case 2:
        i =
          (msg.charCodeAt(msg_len - 2) << 24) |
          (msg.charCodeAt(msg_len - 1) << 16) |
          0x08000;
        break;
      case 3:
        i =
          (msg.charCodeAt(msg_len - 3) << 24) |
          (msg.charCodeAt(msg_len - 2) << 16) |
          (msg.charCodeAt(msg_len - 1) << 8) |
          0x80;
        break;
    }
    word_array.push(i);
    while (word_array.length % 16 != 14) word_array.push(0);
    word_array.push(msg_len >>> 29);
    word_array.push((msg_len << 3) & 0x0ffffffff);
    for (blockstart = 0; blockstart < word_array.length; blockstart += 16) {
      for (i = 0; i < 16; i++) W[i] = word_array[blockstart + i];
      for (i = 16; i <= 79; i++)
        W[i] = rotate_left(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
      A = H0;
      B = H1;
      C = H2;
      D = H3;
      E = H4;
      for (i = 0; i <= 19; i++) {
        temp =
          (rotate_left(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5a827999) &
          0x0ffffffff;
        E = D;
        D = C;
        C = rotate_left(B, 30);
        B = A;
        A = temp;
      }
      for (i = 20; i <= 39; i++) {
        temp =
          (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1) &
          0x0ffffffff;
        E = D;
        D = C;
        C = rotate_left(B, 30);
        B = A;
        A = temp;
      }
      for (i = 40; i <= 59; i++) {
        temp =
          (rotate_left(A, 5) +
            ((B & C) | (B & D) | (C & D)) +
            E +
            W[i] +
            0x8f1bbcdc) &
          0x0ffffffff;
        E = D;
        D = C;
        C = rotate_left(B, 30);
        B = A;
        A = temp;
      }
      for (i = 60; i <= 79; i++) {
        temp =
          (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6) &
          0x0ffffffff;
        E = D;
        D = C;
        C = rotate_left(B, 30);
        B = A;
        A = temp;
      }
      H0 = (H0 + A) & 0x0ffffffff;
      H1 = (H1 + B) & 0x0ffffffff;
      H2 = (H2 + C) & 0x0ffffffff;
      H3 = (H3 + D) & 0x0ffffffff;
      H4 = (H4 + E) & 0x0ffffffff;
    }
    temp = cvt_hex(H0) + cvt_hex(H1) + cvt_hex(H2) + cvt_hex(H3) + cvt_hex(H4);

    return temp.toLowerCase();
  }

  myAisToken() {
    if (this.userData) {
      let randomChar = Math.random().toString(36).substr(2, 4);
      let firstConvert = this.SHA1('a#BAC@21' + randomChar);
      this.myaisToken = randomChar.concat(firstConvert);
      if (devEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://myais.vas.dev.nascorp.vn/loginservice/${this.myaisToken}`);
      } else if (testEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://myais.eca.test.nascorp.vn/loginservice/${this.myaisToken}`);
      } else if (stagingEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://uat-myais.aisvietnam.com/loginservice/${this.myaisToken}`);
      } else if (procEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://myais.vn/loginservice/${this.myaisToken}`);
      } else if (localEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://myais.vas.dev.nascorp.vn/loginservice/${this.myaisToken}`);
      } else if (demoEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://myais.demo.nascorp.vn/loginservice/${this.myaisToken}`);
      }
      
    } else {
      // Redirect to desired URL
      if (Object.values(devEnv).indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://${devEnv.services}`);
      } else if (Object.values(testEnv).indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://${testEnv.services}`);
      } else if (Object.values(stagingEnv).indexOf(this.hostName) !== -1) {
        return (window.location.href = `https://${stagingEnv.services}`);
      } else if (Object.values(procEnv).indexOf(this.hostName) !== -1) {
        return (window.location.href = `https://${procEnv.services}`);
      } else if (Object.values(demoEnv).indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://${demoEnv.services}`);
      } else if (Object.values(bisHanoiEnv).indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://${bisHanoiEnv.services}`);
      } else if (Object.values(bisHanoiDevEnv).indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://${bisHanoiDevEnv.services}`);
      } else if (Object.values(ishcmcEnv).indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://${ishcmcEnv.services}`);
      } else if (Object.values(aavnIshcmcEnv).indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://${aavnIshcmcEnv.services}`);
      } else if (Object.values(primaryIshcmcEnv).indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://${primaryIshcmcEnv.services}`);
      } else if (Object.values(secondaryIshcmcEnv).indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://${secondaryIshcmcEnv.services}`);
      } else if (Object.values(isspEnv).indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://${isspEnv.services}`);
      } else if (Object.values(demoHelenEnv).indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://${demoHelenEnv.services}`);
      } else {
        return (window.location.href = `http://${localEnv.services}`);
      }
    }
  }

  toHandbook() {
    window.open(
      'http://www.aisvietnam.com/wp-content/Parent%20Handbook%202018-2019.pdf',
      '_blank'
    );
  }

  toReen() {
    switch (this.hostName) {
      case procEnv.auth:
        window.location.href = `https://${procEnv.reen}/reen/admin/`;
        break;
      case devEnv.auth:
        window.location.href = `http://${devEnv.reen}/reen/admin/`;
        break;
      case testEnv.auth:
        window.location.href = `http://${testEnv.reen}/reen/admin/`;
        break;
      case bisHanoiEnv.auth:
        window.location.href = `http://${bisHanoiEnv.reen}/reen/admin/`;
        break;
      case bisHanoiDevEnv.auth:
        window.location.href = `http://${bisHanoiDevEnv.reen}/reen/admin/`;
        break;
      case bisHanoiStagingEnv.auth:
        window.location.href = `http://${bisHanoiStagingEnv.reen}/reen/admin/`;
        break;
      case ishcmcEnv.auth:
        window.location.href = `http://${ishcmcEnv.reen}/reen/admin/`;
        break;
      case aavnIshcmcEnv.auth:
        window.location.href = `http://${aavnIshcmcEnv.reen}/reen/admin/`;
        break;
      case primaryIshcmcEnv.auth:
        window.location.href = `http://${primaryIshcmcEnv.reen}/reen/admin/`;
        break;
      case secondaryIshcmcEnv.auth:
        window.location.href = `http://${secondaryIshcmcEnv.reen}/reen/admin/`;
        break;
      case isspEnv.auth:
        window.location.href = `http://${isspEnv.reen}/reen/admin/`;
        break;
      case demoHelenEnv.auth:
        window.location.href = `http://${demoHelenEnv.reen}/reen/admin/`;
        break;
      case stagingEnv.auth:
        window.location.href = `https://${stagingEnv.reen}/reen/admin/`;
        break;
      case demoEnv.auth:
        window.location.href = `http://${demoEnv.reen}/reen/admin/`;
        break;
      default:
        window.location.href = `http://${localEnv.reen}/reen/admin/`;
        break;
    }
  }
}


// WEBPACK FOOTER //
// ./src/auth/navigate-page/NavigateComponent.ts